/**
 * Broadcaster: размер окна → снимки mobile/desktop page size.
 * Контракт подписчика: subscribe(listener) возвращает unsubscribe().
 */
export class ViewportBreakpointBroadcaster {
  /**
   * @param {{
   *   mobileMaxWidthPx: number,
   *   mobilePageSize: number,
   *   desktopPageSize: number,
   *   resizeDebounceMs?: number,
   * }} options
   */
  constructor(options) {
    this.mobileMaxWidthPx = Number(options.mobileMaxWidthPx);
    this.mobilePageSize = Number(options.mobilePageSize);
    this.desktopPageSize = Number(options.desktopPageSize);
    this.resizeDebounceMs = Number(options.resizeDebounceMs ?? 150);
    this.subscribers = new Set();
    this.debounceTimerId = null;
    this.started = false;
    this.handleResize = this.handleResize.bind(this);
  }

  /**
   * @returns {{ isMobile: boolean, pageSize: number, viewportWidth: number }}
   */
  getSnapshot() {
    const viewportWidth = typeof window !== 'undefined' ? window.innerWidth : this.mobileMaxWidthPx + 1;
    const isMobile = viewportWidth <= this.mobileMaxWidthPx;
    return {
      isMobile,
      pageSize: isMobile ? this.mobilePageSize : this.desktopPageSize,
      viewportWidth,
    };
  }

  /**
   * @param {(snapshot: { isMobile: boolean, pageSize: number, viewportWidth: number }) => void} listener
   * @returns {() => void} unsubscribe
   */
  subscribe(listener) {
    this.subscribers.add(listener);
    return () => {
      this.subscribers.delete(listener);
    };
  }

  start() {
    if (this.started || typeof window === 'undefined') {
      return;
    }
    this.started = true;
    window.addEventListener('resize', this.handleResize);
    this.publish(this.getSnapshot());
  }

  stop() {
    if (!this.started || typeof window === 'undefined') {
      return;
    }
    this.started = false;
    window.removeEventListener('resize', this.handleResize);
    if (this.debounceTimerId !== null) {
      window.clearTimeout(this.debounceTimerId);
      this.debounceTimerId = null;
    }
  }

  handleResize() {
    if (this.debounceTimerId !== null) {
      window.clearTimeout(this.debounceTimerId);
    }
    this.debounceTimerId = window.setTimeout(() => {
      this.debounceTimerId = null;
      this.publish(this.getSnapshot());
    }, this.resizeDebounceMs);
  }

  /**
   * @param {{ isMobile: boolean, pageSize: number, viewportWidth: number }} snapshot
   */
  publish(snapshot) {
    this.subscribers.forEach((listener) => {
      listener(snapshot);
    });
  }
}
